// extracted by mini-css-extract-plugin
export default {"infoBubble":"InfoBubble_infoBubble__oq4xg","arrow":"InfoBubble_arrow__Qj9rv","body":"InfoBubble_body__AHWk0","text":"InfoBubble_text__koI-H"};